export default {
  fallbackLocale: 'ru',
};
